const HTML_TAG_REGEX = /(<([^>]+)>)/gi;
const CHAR_LIMIT = 10000;

export const stripHtmlAndWhitespace = (text: string): string =>
  text.replace(/&nbsp;/g, "").replace(HTML_TAG_REGEX, "").replace(/\s/g, "").replace(/\n/g, "");

export const isFieldEmpty = (text: string): boolean =>
  stripHtmlAndWhitespace(text).length < 1;

export const exceedsCharLimit = (text: string): boolean =>
  text.length > CHAR_LIMIT;
